/**
 * Simple configuration for iBest.
 * Auto-detects environment - no .env needed!
 */

const isDev = import.meta.env.DEV;

export const config = {
  isDev,

  api: {
    baseUrl: '/api',
    timeout: 30000 // 30 second default timeout
  },

  features: {
    // Feature flags - toggle features on/off
    enableIndexedDB: true, // Save form data locally
    enablePrintLayout: true, // Print-friendly layouts
    enableRetry: true // Auto-retry failed API calls
  }
} as const;

// Type-safe config
export type Config = typeof config;

/**
 * Usage examples:
 *
 * // Check feature flag before using:
 * if (config.features.enableIndexedDB) {
 *   await saveToIndexedDB(data);
 * }
 *
 * // API calls use config.api.baseUrl automatically
 * const result = await apiPost('/endpoint', data);
 */
